import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {ConfigService} from './config.service';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {BasicResponse} from '@auth-suite-services/services';
import {SystemSetupInterface, SystemSetupInterfaceAPI} from '../..';

@Injectable({
  providedIn: 'root'
})
export class SystemsetupService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(ConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'SDSETUP').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllSystemSetup(pageIndex: number, pageSize: number, sortActive: string, sort: string): Observable<SystemSetupInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<SystemSetupInterfaceAPI>(`${this.URL}/ssu/getallsystemsetup/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}`, {headers}).pipe(catchError(this.handleError));
  }

  getSystemSetup(id: number): Observable<SystemSetupInterface> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<SystemSetupInterface>(`${this.URL}/ssu/getsystemsetup/${id}`, {headers}).pipe(catchError(this.handleError));
  }

  updateSSU(ssu: SystemSetupInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update ssu: ' + JSON.stringify(ssu));
    return this.httpClient.post<BasicResponse>(`${this.URL}/ssu/updatesystemsetup`, ssu, {headers}).pipe(catchError(this.handleError));
  }

  createSSU(ssu: SystemSetupInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update ssu: ' + JSON.stringify(ssu));
    return this.httpClient.post<BasicResponse>(`${this.URL}/ssu/createsystemsetup`, ssu, {headers}).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }
}
